import React from "react";

export function CompassLogo({ size = 34, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <circle cx="24" cy="24" r="21" fill="#22314F" />
      <circle cx="24" cy="24" r="21" stroke="#E8A33D" strokeWidth="2.5" />
      <circle cx="24" cy="24" r="15" stroke="#E8E3D8" strokeWidth="1" opacity="0.35" />
      <path d="M24 10 L29 24 L24 21 Z" fill="#E8A33D" />
      <path d="M24 38 L19 24 L24 27 Z" fill="#FAF9F6" />
      <circle cx="24" cy="24" r="2.4" fill="#FAF9F6" />
    </svg>
  );
}
